// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".absolute[data-v-78e04e0b] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n}\n.image-block-disabled[data-v-78e04e0b] {\n  padding-top: 3rem;\n}", ""]);
// Exports
module.exports = exports;
